import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Banner from '../../components/Banner/Banner';
import HomeBanner from '../../assets/banner2.jpg';
import HomeBanner2 from '../../assets/model.jpg';
import HomeBanner3 from '../../assets/banner6.jpg';
import Announcement from '../../components/Announcement/Announcement';
import CategoryHub from '../../components/CategoryHub/CategoryHub';
import Footer from '../../components/Footer/Footer';
import ProductHub from '../../components/ProductHub/ProductHub';
import InfoSection from '../../components/InfoSection/InfoSection';

const Home = () => {
  return (
    <div className='page__wrapper'>
      <Navbar />
      <Banner  imgSrc={HomeBanner} imgAlt={"Alex Menswear Suits & Blazers"}/>
      <CategoryHub />
      <Banner  imgSrc={HomeBanner2} imgAlt={"Alex Menswear & Luxury Clothing"}/>
      <Announcement myAnnouncement={"The Apex Fall-Winter 2025 Suit Collection"} />
      <ProductHub />
      <Banner  imgSrc={HomeBanner3} imgAlt={"Alex Menswear & Luxury Clothing"}/>
      <InfoSection />
      <Footer />
      
    </div>
  )
}

export default Home
